import React from 'react';
import { Flex, Text, TextButton } from '@amzn/storm-ui';
import { useSelector } from 'react-redux';
import { selectPageLayoutType } from 'src/app/slice';
import { DesktopToggleWrap, FooterWrapper } from './Footer.styles';
import { FooterComponentProps } from './Footer.types';
import { getTaktAttributes } from 'src/commons/utils/logWithTakt';
import { chromeComponents } from 'src/constants';
import { StyledLink } from 'src/commons/components/StyledLink';

const Desktop: React.VFC<FooterComponentProps> = ({
  copyright,
  links,
  toggleText,
  toggleView,
  isFooterLinkEnabled,
}) => {
  const pageLayoutType = useSelector(selectPageLayoutType);

  return (
    <FooterWrapper id="footer" pageLayoutType={pageLayoutType}>
      {/* TODO: Remove the toggle button below */}
      {isFooterLinkEnabled && toggleText && toggleView && (
        <DesktopToggleWrap>
          <TextButton style={{ fontSize: '40px' }} onClick={toggleView}>
            {toggleText}
          </TextButton>
        </DesktopToggleWrap>
      )}
      <Flex alignItems="center" justifyContent="center" columnGap="base">
        <Text color="secondary" renderAs="span">
          {copyright}
        </Text>
        {links &&
          links.map((link) => (
            <StyledLink
              key={link.label}
              href={link.url}
              {...getTaktAttributes('link', chromeComponents.FOOTER, {
                url: link.url,
                label: link.label,
              })}
            >
              {link.label}
            </StyledLink>
          ))}
      </Flex>
    </FooterWrapper>
  );
};

export default Desktop;
